import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { setSubChildId } from "Administrator/modules/AdministratorModule";

export default store => ({
  path: "announcement-settings",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "admin-announcement-settings" */ "./components"
        ),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    // .catch(err => {
    //   return err;
    // })
  ),
  onEnter() {
    store.dispatch(setSubChildId("ANNOUNCEMENT_SETTINGS"));
  },
  onLeave() {
    store.dispatch(setSubChildId(""));
  },
});
